import React from "react"

const height = 479
const width = 800
const showPost = 1

export default ( props ) => (
  <iframe src={props.url + "&show_text=" + showPost + "&width=" + width + "&height=" + height} width={width} height={height} title="Sermon Video" style={{ border: 'none', overflow: 'hidden' }} scrolling="no" frameborder="0" allowTransparency="true" allow="encrypted-media" allowFullScreen="true"></iframe>
)